import moment from 'moment';
import auth from '@/utils/auth';

/**
 * 投保需授權的資料
 * @returns {Object}
 */
const state = () => ({
    account: null,
    birthday: null,
    header: null,
    token: null,
    refreshTokenExpire: null,
    refreshTokenExpireSec: null,
    jwtExpire: null,
    jwtExpireSec: null, // login時用client端紀錄，大約15分鐘
    lastLoginIp: null,
    refreshProcessing: false, // 已送出 refresh api 處理中
    // 續保用
    renewal: false,
    // 投保後查詢
    estimateId: null,
    register: false, // 首次註冊
    refreshToken: null, //提醒： 僅供開發時期測試使用，正式網址會直接用 cookie
    appKey:null //後續呼叫 refreshToken, logOut 使用
});

const actions = {};

const getters = {
    /**
     * 是否為登入狀態
     * @param {*} state
     * @returns {Boolean}
     */
    loggedIn: (state) => {
        return !!state.token && state.jwtExpireSec > 0;
    },
    /**
     * 可刷新 token
     * token 有值且 refresh token 沒過期
     * @param state
     * @returns {Boolean}
     */
    refreshable: (state) => {
        return !!state.refreshTokenExpire && state.refreshTokenExpireSec > 0;
    },
    /**
     * 有 jwt token 且 jwt token 已過期
     * @param state
     * @returns {Boolean}
     */
    expired: (state) => {
        return !!state.token && state.jwtExpireSec <= 0;
    },
};

const mutations = {
    /**
     * 登入
     * @param {*} state
     * @param {*} payload
     * @returns
     */
    login(state, payload) {
        if (!payload || !payload.token) return false;
        //SSO登入時，jwtInfo可能已過期
        if(moment(payload.refreshTokenExpire).isAfter()) {
            state.header = payload.header;
            state.token = payload.token;
            state.refreshTokenExpire = payload.refreshTokenExpire;
            state.refreshTokenExpireSec = payload.refreshTokenExpireSec;
            state.jwtExpire = moment().add(process.env.VUE_APP_JWT_EXPIRE_TIME, 'seconds').format('YYYY-MM-DDTHH:mm:ss.SSS');
            state.jwtExpireSec = process.env.VUE_APP_JWT_EXPIRE_TIME;
            state.lastLoginIp = payload.lastLoginIp;
            state.refreshToken = payload.refreshToken || null; //提醒： 僅供開發時期測試使用，正式網址會直接用 cookie
            state.appKey = payload.appKey;
            
            auth.setJwtInfo(payload);
        }
    },
    /**
     * 登出
     * @param {*} state
     */
    logout(state) {
        state.account = null;
        state.birthday = null;
        state.header = null;
        state.token = null;
        state.refreshTokenExpire = null;
        state.refreshTokenExpireSec = null;
        state.jwtExpire = null;
        state.jwtExpireSec = null;
        state.lastLoginIp = null;
        state.refreshProcessing = false;
        state.renewal = false;
        state.refreshToken = null;
        state.register = false;
        state.appKey = null;

        auth.removeJwtInfo();
    },
    /**
     * 身分證字號/居留證號碼
     * @param {*} state
     * @param {*} payload
     */
    setAccount(state, payload) {
        state.account = payload;
    },
    /**
     * 生日
     * @param {*} state
     * @param {*} payload
     */
    setBirthday(state, payload) {
        state.birthday = payload;
    },
    /**
     * 網路要保序號
     * @param {*} state
     * @param {*} payload
     */
    setEstimateId(state, payload) {
        state.estimateId = payload;
    },
    /**
     * 每秒 token 倒數
     */
    countdown(state) {
        if (state.refreshTokenExpireSec) state.refreshTokenExpireSec -= 1;
        if (state.jwtExpireSec) state.jwtExpireSec -= 1;
    },
    /**
     * 設定 refresh 的 API 是否在處理中，以免重複呼叫
     * @param {*} state
     * @param {*} payload
     */
    setRefreshProcessing(state, payload) {
        state.refreshProcessing = payload;
    },
    /**
     * 保留該參數用來判斷 user 是否完成“註冊“流程
     * @param {*} state
     * @param {*} payload
     */
    registered(state) {
        state.register = true;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
